import * as React from "react";
import clsx from "clsx";
import {
  useCpFormAnyValue,
  useCpFormError,
  useCpFormSimulateTouched,
  useCpFormTouched,
  useCpFormWarning,
} from "./utils";

interface Props {
  name: string;
  arrayItem?: boolean;
}

export function CpErrorWarning({ name, arrayItem }: Props) {
  const isRoot = React.useMemo(() => {
    return name.endsWith(`root`);
  }, [name]);
  const submitted = useCpFormAnyValue(`meta.submitted`);
  const simulateTouched = useCpFormSimulateTouched(name);
  const touched = useCpFormTouched(name);
  const error = useCpFormError(name);
  const warning = useCpFormWarning(name);

  const canShowErrorStatus = React.useMemo(() => {
    return submitted || simulateTouched || touched || isRoot;
  }, [submitted, simulateTouched, touched, isRoot]);

  const canShowWarningStatus = React.useMemo(() => {
    // Always show warnings regardless of touched state, but only if no error
    // If there's an error, defer to canShowErrorStatus
    if (error) {
      return canShowErrorStatus;
    }
    return true;
  }, [error, canShowErrorStatus]);

  if (
    arrayItem && //
    ((!canShowErrorStatus && !canShowWarningStatus) || //
      (!error && !warning))
  ) {
    return null;
  }

  return (
    <div
      className={clsx(`text-sm mt-1`, {
        "color-danger": canShowErrorStatus && error,
        "color-warning": canShowWarningStatus && !error && warning,
        invisible: (!canShowErrorStatus && !canShowWarningStatus) || (!error && !warning),
      })}
    >
      {error || warning || "-"}
    </div>
  );
}
